import React from 'react';
import { Form, Input, Button, Row, Col, InputNumber } from 'antd';
import useMessage from 'antd/es/message/useMessage';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import { UserService } from '../../../Services/Manage/UserService';

const AddGenerator = ({ initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();
    const [message, messagecontxt] = useMessage();

    const handleFinish = async (values) => {
        try {
            const user = await UserService.getOmeUser();

            const payload = {
                ...values,
                added_by: user.uid,
                updated_on: new Date().toISOString().slice(0, 16).replace("T", " "),
                added_on: new Date().toISOString().slice(0, 16).replace("T", " "),
            };

            console.log("payload",payload);
            

            if (initialValues?.id) {
                const req = await ServicetypeService.updateGene(
                    payload,
                    initialValues.id
                );

                if (req.status) {
                    message.success(req.message);
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message);
                }
            } else {
                const req = await ServicetypeService.createGen(payload);

                if (req.status) {
                    message.success(req.message);
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message);
                }
            }
        } catch (error) {
            console.error("Service operation failed:", error);
            message.error("Something went wrong");
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={initialValues || {}}
            onFinish={handleFinish}
        >
            <Row gutter={16}>

                <Col span={24}>
                    <Form.Item name="name" label="Generator Name">
                        <Input.TextArea rows={2} size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="sku" label="HSN/SAC/SKU Code">
                        <Input size="large" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="unit" label="Unit">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="capacity" label="Capacity (KVA / KW)">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="engine_model" label="Engine Model">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="cooling_type" label="Cooling Type">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="engine_bhp" label="Engine BHP">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="alternator_capacity" label="Alternator Capacity (KVA)">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="price" label="Price">
                        <InputNumber  style={{width:'100%'}} size="large" />
                    </Form.Item>
                </Col>


                <Col span={12}>
                    <Form.Item name="gst" label="GST (in %)">
                        <InputNumber style={{width:'100%'}} size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="freight" label="Freight">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="unload_shifting" label="Unload & Shifting">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="validity" label="Validity">
                        <Input size="large" />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item name="warranty" label="Warranty">
                        <Input size="large" />
                    </Form.Item>
                </Col>


                <Col span={24}>
                    <Form.Item name="scope_of_supply" label="Scope of Supply">
                        <Input.TextArea size="large" rows={2} />
                    </Form.Item>
                </Col>

            </Row>

            <div style={{ textAlign: 'right' }}>
                <Button onClick={onCancel} style={{ marginRight: 8 }} size="large">
                    Cancel
                </Button>
                <Button type="primary" htmlType="submit" size="large">
                    {initialValues ? 'Update' : 'Create'}
                </Button>
                {messagecontxt}
            </div>
        </Form>
    );
};

export default AddGenerator;
